export const SubSection = ({
  children,
  id,
  title,
  className,
}: {
  children: React.ReactNode;
  id?: string;
  title?: string;
  className?: string;
}) => {
  return (
    <div className={`${className ? className : ""} py-[20px]`}>
      {title ? (
        <h2
          id={id}
          className={`text-2xl font-medium mb-5 ${id ? "scroll-mt-20" : ""}`}
        >
          {title}
        </h2>
      ) : null}
      <div className="flex flex-col gap-8">{children}</div>
    </div>
  );
};
